<template>
  <div id="contenedor-agregar-imagen-usuario">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar Imagen de Usuario
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <template v-if="!rutaArchivo">
            <v-row justify="center">
              <div
                class="contenedor-imagen-agregar"
                @click="$refs.seleccionarAnexo.click()">
                <v-img
                  src="@/assets/add-img-img.png"
                  contain
                  height="100"
                  width="100">
                </v-img>
              </div>
            </v-row>
          </template>
          <template v-if="rutaArchivo">
            <v-row justify="center">
              <v-img
                :src="rutaArchivo"
                height="300"
                width="300"
                contain
                class="blue-grey darken-4">
                <div class="contenedor-imagenes-remover-imagen">
                  <v-btn
                    small
                    icon
                    dark
                    @click="$refs.seleccionarAnexo.click()">
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </div>
              </v-img>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="guardar"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario">
          </custom-button>
        </v-card-actions>
      </v-card>
    <input
        type="file"
        ref="seleccionarAnexo"
        id="anexo"
        class="d-none"
        accept="image/jpeg, image/png, image/bmp"
        capture="camera"
        @change="seleccion">
  </div>
</template>

<script>
import mixCatalogoUsuarios from './mixCatalogoUsuarios';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';
import CustomButton from '@/components/buttons/Button.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'AgregarImagenUsuario',
  mixins: [mixCatalogoUsuarios, mixSubirArchivo],
  props: {
    usuarioId: {
      type: String,
      required: true,
    },
    datosUsuario: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
      formularioValido: false,
      rutaArchivo: null,
      usuario: {
        avatarPublicKey: '',
      },
    };
  },
  methods: {
    async guardar() {
      // si existe una ruta de archivo, se sube el archivo al servidor
      this.enviandoFormulario = true;
      if (this.rutaArchivo) {
        const datosArchivo = this.setDatosArchivo();
        await this.mixSubirArchivo(datosArchivo);
      }
      await this.mixActualizarUsuarioBasico();
      this.$auth.user.avatarPublicKey = this.usuario.avatarPublicKey;
    },
    setDatosArchivo() {
      const datosArchivo = {
        nombre: `${this.datosUsuario.funcionario.nombre}`,
        path: 'Perfil Usuarios/imagenes',
      };
      return datosArchivo;
    },
    removerImagen() {
      this.rutaArchivo = null;
    },
    seleccion() {
      this.formularioValido = true;
      this.rutaArchivo = URL.createObjectURL(
        document.getElementById('anexo').files[0],
      );
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
  mounted() {
    eventBus.$on('seCargoArchivo', (archivo) => {
      this.usuario.avatarPublicKey = archivo.data.public_key;
    });
  },

};
</script>

<style lang="scss" scoped>
.contenedor-imagenes-remover-imagen {
  position: absolute;
  top: 5px;
  right: 5px;
}
.contenedor-imagen-agregar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  height: 180px;
  width: 180px;
  padding: 1em;
  border-radius: .5rem;
  cursor: pointer;
}
.contenedor-imagen-agregar:hover {
  border: 2px solid #ccc;
}
</style>
